export default __webpack_public_path__ + "static/media/magentapinata.27562933.png";